import React, { useState, useEffect, useWindowFocus } from "react";

import {
  Link,
  Route,
  Routes,
  useParams,
  useNavigate,
  useLocation,
} from "react-router-dom";

import {
  getDoc,
  updateDoc,
  collection,
  addDoc,
  query,
  where,
  getDocs,
  deleteDoc,
  doc,
  setDoc,
  getCountFromServer,
  arrayUnion,
} from "@firebase/firestore";

import { auth, firebase } from "../Firebase/config";

import Classes from "./Mapoflastten/Mapoflastten";

// eslint-disable-next-line
import NavBar from "./Navbar";

import "./App.css";

function App() {
  const [temparray, setTemparray] = useState();

  const [selectedclass, setSelectedclass] = useState();
  const [activeid, setActiveid] = useState();
  const [activename, setActivename] = useState();

  const [selectedclass2, setSelectedclass2] = useState();
  const [activeid2, setActiveid2] = useState();
  const [activename2, setActivename2] = useState();
  const [activeemail2, setactiveemail2] = useState();

  const [currentclass, setCurrentclass] = useState();

  const [currentclasses, setCurrentclasses] = useState();
  const [currentstudents, setCurrentstudents] = useState();

  const [accesstoken, setAccesstoken] = useState();
  const [refreshtoken, setRefreshtoken] = useState();
  const [expiryDate, setExpiryDate] = useState();

  const [assignmentname, setAssignmentname] = useState();
  const [assignmentid, setAssignmentid] = useState();

  const { only2studentid, studentid, classid, language, role, id } = useParams();

  const [town, setTown] = useState("");
  const [state, setState] = useState("");
  const [school, setSchool] = useState("");

  const [localemailaddress, setLocalemailaddress] = useState("");

  // Add a state to track when user data is loaded
  const [userDataLoaded, setUserDataLoaded] = useState(false);
  // Add a state to trigger reload if loading takes too long
  const [reloadKey, setReloadKey] = useState(0);

  // Minimal mount check
  useEffect(() => {
    console.log("App component mounted");
  }, []);

  // If loading takes more than 2 seconds, reload the page
  // useEffect(() => {
  //   if (!userDataLoaded) {
  //     const timeout = setTimeout(() => {
  //       if (!userDataLoaded) {
  //         console.warn("⏳ Still loading after 2 seconds, reloading page...");
  //         window.location.reload();
  //       }
  //     }, 2000);
  //     return () => clearTimeout(timeout);
  //   }
  // }, [userDataLoaded]);

  // On mount, get id from URL and fetch all user data from Firestore ONCE
  useEffect(() => {
    // const urlParams = new URLSearchParams(window.location.search);
    // const urlId = urlParams.get("id");
    // const dataStoredInDatabase = urlParams.get("dataStoredInDatabase");

    // console.log("useEffect: urlId =", urlId, "dataStoredInDatabase =", dataStoredInDatabase);

    // if (!urlId || dataStoredInDatabase !== "true") {
    //   console.log("id or dataStoredInDatabase not present in URL, skipping Firestore fetch");
    //   setUserDataLoaded(true);
    //   return;
    // }

    const fetchAllUserData = async () => {
      try {
        console.log("Fetching user data from Firestore for id:", id);

        const docRef = doc(firebase, "users", id);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          const userDoc = docSnap.data();

          // Assignments and tokens
          setTemparray(userDoc.gogetlastttengcassiignments || []);
          setAccesstoken(userDoc.access_token || "");
          setRefreshtoken(userDoc.refresh_token || "");
          setExpiryDate(userDoc.expiry_date || "");
          setLocalemailaddress(userDoc.email || "");

          // All other user info
          if (userDoc.activeclassid) {
            setActiveid(userDoc.activeclassid);
            console.log("✅ Active class ID set:", userDoc.activeclassid);
          } else {
            console.warn("⚠️ No active class ID found for user");
          }

          if (userDoc.activeclassname) {
            setActivename(userDoc.activeclassname);
            console.log("✅ Active class name set:", userDoc.activeclassname);
          } else {
            console.warn("⚠️ No active class name found for user");
          }

          if (userDoc.gclassroomid) {
            setActiveid2(userDoc.gclassroomid);
            console.log("✅ Google Id set:", userDoc.gclassroomid);
          } else {
            console.warn("⚠️ No Google Id found for user");
          }

          if (userDoc.gclassroomname) {
            setActivename2(userDoc.gclassroomname);
            console.log("✅ Google classroom name set:", userDoc.gclassroomname);
          } else {
            console.warn("⚠️ No Google classroom name found for user");
          }

          if (userDoc.town) {
            setTown(userDoc.town);
            console.log("✅ Town set:", userDoc.town);
          }

          if (userDoc.state) {
            setState(userDoc.state);
            console.log("✅ State set:", userDoc.state);
          }

          if (userDoc.school) {
            setSchool(userDoc.school);
            console.log("✅ School set:", userDoc.school);
          }

        } else {
          console.warn("⚠️ No document found in Firestore for user id:");
        }
      } catch (error) {
        console.error("❌ Error fetching user data from Firestore:", error);
      }
      setUserDataLoaded(true);
    };

    fetchAllUserData();
  }, [id]);

  useEffect(() => {
    if (typeof selectedclass2 != "undefined") {
      setAssignmentid(selectedclass2.id);
      setAssignmentname(selectedclass2.title);
      console.log("selectedclass2 changed:", selectedclass2);
    }
  }, [selectedclass2]);

  useEffect(() => {
    if (typeof assignmentid != "undefined" && typeof assignmentname != "undefined") {
      updateDoc(doc(firebase, "users", id), {
        "fetchGradesOfSelectedAssignment": {
          studentsWithGrades: [],
          assignmentName: assignmentname,
          assignmentId: assignmentid,
          lastUpdated: new Date().toISOString()
        }
      }).catch((error) => {
        console.log("Error updating fetchGradesOfSelectedAssignment:", error);
      });
      console.log("Updated fetchGradesOfSelectedAssignment with", assignmentid, assignmentname);
    }
  }, [assignmentid, assignmentname]);

  // Remove the old user data fetch useEffect and the old initialization useEffect
  return (
    <div className="App22">

          <NavBar
            role={role}
            temparray={currentclasses}
            activename2={activename2}
            selectedclass={selectedclass}
            setSelectedclass={setSelectedclass}
            activename={activename}
            //because it is an endpoint than you need to returrn from.
            noclasschangeandmainmenuonly={true}
          />
          <div className="App">
            <header className="App-header">
              {/* 
                <Link to="/" style={{ textDecoration: 'none' }}>
              Return Home
              </Link> */}

              <Classes
                currentclass={currentclass}
                activename={activename}
                activename2={activename2}
                setSelectedclass={setSelectedclass2}
                activeid2={activeid2}
                selectedclass={selectedclass2}
                temparray={temparray}
                id={id}
                activeid={activeid}
                assignmentname={assignmentname}
                assignmentid={assignmentid}
                accesstokenn={accesstoken}
                refreshtokenn={refreshtoken}
                expirydatee={expiryDate}
                localemailaddress={localemailaddress}
              />
            </header>
          </div>
 
    </div>
  );
}

export default App;

